// extracted by mini-css-extract-plugin
export default {"figure":"StockPieChart_figure__2Yzip","chart":"StockPieChart_chart__r4OxJ"};